const pluralize = (word: string, count: number, plural: string | null = null): string => {
  const suffix = word.endsWith("s") ? "es" : "s";
  return count === 1 ? word : plural ?? `${word}${suffix}`;
};

export default pluralize;
